export default __webpack_public_path__ + "static/media/error404_dark.09462317.svg";